import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import toast from "react-hot-toast";
import { PAY_URL } from "../../../BaseURL";

export const addUserEmployeeType = createAsyncThunk(
    '/add/addUserEmployeeType',
    async (add) => {

        try {
            const myurl = `${PAY_URL}/user/manage-employee-type`;

            const response = await axios({
                method: 'post',
                url: myurl,
                data: add,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    Authorization: "Bearer " + localStorage.getItem('PAY_USER_TOKEN')
                },
            });

            const addUserEmployeeType = response.data;
            // console.log(addUserEmployeeType, '@@@')

            if (addUserEmployeeType.success === true) {
                toast.success(addUserEmployeeType?.message);
                return addUserEmployeeType;
            } else {
                // console.log(addUserEmployeeType.message, "&&&&")
                throw new Error(addUserEmployeeType.message);
            }
        } catch (error) {
            console.log(error, "!!!!")
            toast.error(error.response.data.message);
            return error;
        }
    }
);


const addUserEmployeeTypeSlice = createSlice({
    name: "addUserEmployeeType",
    initialState: {
        user: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(addUserEmployeeType.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(addUserEmployeeType.fulfilled, (state, action) => {
                state.user = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(addUserEmployeeType.rejected, (state, action) => {
                state.user = null;
                state.loading = false;
                state.error = action.error.message;
            });
    }
})

export default addUserEmployeeTypeSlice.reducer;